import { TextBlock } from "./blocks/TextBlock";
import { ContainerBlock } from "./blocks/ContainerBlock";
import { SectionBlock } from "./blocks/SectionBlock";
import { RowBlock } from "./blocks/RowBlock";
import { ColumnBlock } from "./blocks/ColumnBlock";
import { ImageBlock } from "./blocks/ImageBlock";
import { ButtonLinkBlock } from "./blocks/ButtonLinkBlock";
import { HeroBlock } from "./blocks/HeroBlock";
import { SpacerBlock } from "./blocks/SpacerBlock";
import { DividerBlock } from "./blocks/DividerBlock";
import { VideoBlock } from "./blocks/VideoBlock";
import { IconListBlock } from "./blocks/IconListBlock";
import { QuoteBlock } from "./blocks/QuoteBlock";
import { CardBlock } from "./blocks/CardBlock";
import { GridGalleryBlock } from "./blocks/GridGalleryBlock";
import { HtmlEmbedBlock } from "./blocks/HtmlEmbedBlock";

export const craftResolver = {
  TextBlock,
  ContainerBlock,
  SectionBlock,
  RowBlock,
  ColumnBlock,
  ImageBlock,
  ButtonLinkBlock,
  HeroBlock,
  SpacerBlock,
  DividerBlock,
  VideoBlock,
  IconListBlock,
  QuoteBlock,
  CardBlock,
  GridGalleryBlock,
  HtmlEmbedBlock,
};

export type CraftBlockName = keyof typeof craftResolver;
